import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { AuthAction } from '../redux/action/AuthAction';
import { history } from '../history';
import Loader from "./Loader";

const Login = ({ user, loginResult, Login }) => {
    const [data, setData] = useState({ email: '', password: '', autoLogin: true });
    const [errMsg, setErrMsg] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        document.getElementsByTagName('footer')[0].style.display = 'none';
    }, []);

    useEffect(() => {
        if (loginResult) {
            history.push('/');
        }
    }, [loginResult]);

    const loginHandler = async () => {
        setShowLoader(true);

        const ret = await Login(data);
        if(ret.status !== 'success')
            ret.error && setErrMsg(ret.error);

        setShowLoader(false);
    }

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    }

    return (
        <div className="content-wrapper rt-site image-wrapper bg-image bg-overlay bg-overlay-400 bg-content" data-image-src="/assets/img/bg_signin.jpg" style={{ backgroundImage: 'url(/assets/img/bg_signin.jpg)', height: '100%' }}>
            <section className="wrapper text-white">
                <div className="container pt-12 pb-10 pt-md-21 pb-md-18 signin" style={{ zIndex: 5, position: 'relative' }}>
                    <div className="row gx-0 gy-8 align-items-center">
                        <div className="col-md-10 offset-md-1 offset-lg-0 col-lg-6 content text-center text-lg-start signin-logo" data-cues="slideInDown" data-group="page-title" data-delay="600" data-disabled="true">
                            <a href="#" onClick={(e) => { e.preventDefault(); history.push('/') }}>
                                <img src="/assets/img/bi_rayteams_light.svg" className="mb-5" alt="RAYTeams" data-cue="slideInDown" data-group="page-title" data-delay="600" data-show="true"
                                    style={{
                                        animationName: 'slideInDown',
                                        animationDuration: '700ms',
                                        animationTimingFunction: 'ease',
                                        animationDelay: '600ms',
                                        animationDirection: 'normal',
                                        animationFillMode: 'both'
                                    }}
                                />
                            </a>
                            <p className="lead fs-lg lh-sm" data-cue="slideInDown" data-group="page-title" data-delay="600" data-show="true"
                            style={{
                                animationName: 'slideInDown',
                                animationDuration: '700ms',
                                animationTimingFunction: 'ease',
                                animationDelay: '900ms',
                                animationDirection: 'normal',
                                animationFillMode: 'both'
                            }}
                             >
                                <span className="underline-2 violet">Log in</span> or sign up for RAYTeams.<br />One account for RAYTeams Cloud and client.
                            </p>
                        </div>
                        <div className="col-lg-5 offset-lg-1 signup">
                            <div className="card">
                                <div className="card-body p-11 text-center text-dark">
                                    <h2 className="mb-3 text-start">Log in</h2>
                                    <p className="mb-0 text-start">Please fill out your email and password to log in.</p>
                                    <p className="mb-6 text-start">No account? <a href="#" className="hover" onClick={(e) => { e.preventDefault(); history.push('/signup') }}>Sign up</a></p>
                                    <form className="text-start mb-3">
                                        <div className="form-floating mb-4">
                                            <input type="email" name="email" className="form-control" placeholder="Email" id="loginEmail" onChange={handleChange} onKeyDown={(e) => e.key === 'Enter' && loginHandler()} />
                                            <label htmlFor="loginEmail">Email</label>
                                        </div>
                                        <div className="form-floating password-field mb-4">
                                            <input
                                                type={!showPassword ? "password" : "text"}
                                                name="password"
                                                className="form-control"
                                                placeholder="Password"
                                                id="loginPassword"
                                                onChange={handleChange}
                                                onKeyDown={(e) => e.key === 'Enter' && loginHandler()}
                                            />
                                            <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}><i className={`uil uil-eye${showPassword ? '-slash' : ''}`}></i></span>
                                            <label htmlFor="loginPassword">Password</label>
                                        </div>
                                        <p className="text-danger mt-n2" >{errMsg && errMsg}</p>                                        
                                        <a className="btn btn-primary rounded-pill btn-login w-100 mb-2" onClick={loginHandler}>Log In</a>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id="autoLogin" checked={data.autoLogin} onChange={() => { setData({ ...data, autoLogin: !data.autoLogin }) }} />
                                            <label className="form-check-label text-body" htmlFor="autoLogin"> Auto Login</label>
                                        </div>
                                    </form>
                                    <p className="mb-1 text-end d-none"><a href="#" className="hover">Forgot Password?</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Loader isShow={showLoader} />
        </div>
    )
}

const mapState = (state) => {
    const user = state.AuthReducer.user;
    const loginResult = state.AuthReducer.loginResult;
    return { user, loginResult };
}

const mapDispatch = dispatch => ({
    Login: (data) => dispatch(AuthAction.Login(data))
})

export default connect(mapState, mapDispatch)(Login);